import React from 'react';
import PropTypes from 'prop-types';
import { Container, Row, Col } from 'react-bootstrap';
import cx from 'classnames';
import useCurrentPage from 'website/hooks/useCurrentPage';
import { BUILDER, FACILITY_UNITS_SETTINGS } from 'shared/abilities';
import { section } from '../decorators';
import { createHelpLink } from '../../HelpLink';
import styles from './UnitSizes.scss';

const UnitSizes = ({ children }) => {
  const { primaryColorBackgroundClass } = useCurrentPage();
  const [headerText, units] = React.Children.toArray(children);

  return (
    <div className={cx(styles.body, primaryColorBackgroundClass)}>
      <Container className={styles.maxWidth}>
        <Row>
          <Col md={3}>
            {headerText}
          </Col>
          <Col md={9}>
            <div>{units}</div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

UnitSizes.propTypes = {
  children: PropTypes.node.isRequired,
};

const component = section(
  { name: 'Unit Sizes: Categories / Links', category: 'Unit Displays' },
  {
    subsections: [
      { accepts: ['HeaderText'] },
      { accepts: ['UnitSizes'] },
    ],
    defaults: [
      ['HeaderText', {
        rawContentState: {
          blocks: [
            {
              key: 'db2mm',
              text: 'Select the Perfect Size for You',
              type: 'header-three',
              depth: 0,
              inlineStyleRanges: [
                {
                  offset: 0,
                  length: 31,
                  style: 'COLOR:#ffffff',
                },
              ],
              entityRanges: [],
            },
          ],
          entityMap: {},
        },
      }],
      ['UnitSizes'],
    ],
    menu: {
      items: [
        createHelpLink({
          urlFn: ({ fmsUrl, companyId, facilityId }) =>
            `${fmsUrl}company/${companyId}/facility/${facilityId}/settings/units/groups`,
          text: 'unit groups',
          authorization: { action: 'manage', subject: [BUILDER, FACILITY_UNITS_SETTINGS] },
        }),
        'delete',
      ],
    },
  },
)(UnitSizes);

component.authorization = {};

export default component;
